import React from 'react';
import { Row, Col } from "react-bootstrap";
import ActionButton from './ActionButton';
import SearchBox from '../Filter/SearchBox';
import ScoutSelection from '../Filter/ScoutSelection';
import BoardTabToggle from './BoardTabToggle';
import { useSelector } from 'react-redux';

const BoardHeader = () => {
    const activeTab = useSelector(state => state.scoutKanban.activeTab);
    const isScout = activeTab === "scout";
    return <Row className="kanban-header align-items-center crewManagement_header scout-header_row mx-0">
        {isScout ? <Col lg={4} md={4} sm={4} className="pl-0">
            <div className="kanban-title crewManagement_title mr-3">
                <h4 className="mr-2 my-0">Manage Field Group</h4>
                <div className="d-flex">
                    <ScoutSelection />
                    {/* <CrewSelection />
                    <Recently /> */}
                </div>
            </div>
        </Col> : null}
        {/* <Col lg={4} md={4} sm={4}>
        <div className="d-flex">
            <CrewSelection />
            <Recently />
        </div>
    </Col>
     */}
        {isScout ? <Col lg={4} md={4} sm={4}>
            <div className="crewHeadSearch_filter">
                <SearchBox />
                {/* <EGFilter className='crewCommon_filter' onFilter={egIds => dispatch(setCrewFilteredList(egIds))} /> */}
            </div>
        </Col> : null}
        <Col lg={isScout ? 4 : 12} md={4} sm={4} className="pr-0">
            <div className="d-flex flex-column float-right scout-header crewActions_btn align-items-end">
                {isScout ? <ActionButton /> : null}
                <BoardTabToggle />
                {/* <div className="splitter" /> */}
                {/* <PlanTypeSelection /> */}
            </div>
        </Col>
    </Row>;
}

export default BoardHeader;
